import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Grid, Popover } from '@mui/material';
import { useState } from 'react';
import { WsButton, WsColors, WsTypoColors, WsTypoVariants, WsTypography } from 'wisestep-base';

const SmartFilter = ({ filterName, filterValue, children, onClick, handleClick1 = () => {} }) => {
  const [isExpand, setIsExpand] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const open = Boolean(anchorEl);

  const id = open ? 'simple-popover' : undefined;
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    handleClick1();
    setAnchorEl(event.currentTarget);
    setIsExpand(!isExpand);
  };

  return (
    <>
      <Grid
        item
        container
        gap={1}
        alignItems="center"
        border="1px solid #E0E0E0"
        borderRadius={1}
        px={1}
        bgcolor={WsColors.TertiaryShades50}
        sx={{ flexBasis: 'auto' }}
        onClick={handleClick}
      >
        <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
          {filterName}
        </WsTypography>
        <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.PRIMARY}>
          {filterValue}
        </WsTypography>
        <Box>
          {isExpand ? (
            <ExpandMore sx={{ color: WsColors.TertiaryShades800, fontSize: '15px' }} />
          ) : (
            <ExpandLess sx={{ color: WsColors.TertiaryShades800, fontSize: '15px' }} />
          )}
        </Box>
      </Grid>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            width: '30%',
            maxWidth: '100%',
          },
        }}
      >
        <Grid item xs={12} container sx={{ p: 2, gap: 2, alignItems: 'center' }}>
          <Grid item xs={10}>
            {children}
          </Grid>
          <WsButton
            variant="contained"
            size="small"
            onClick={() => {
              onClick();
              setAnchorEl(null);
            }}
          >
            Apply
          </WsButton>
        </Grid>
      </Popover>
    </>
  );
};

export default SmartFilter;
